export default __webpack_public_path__ + "af96ef53518f8173471f0b1f39488584.png";